import { isEmpty } from 'helpers/utils';
import { SubItem, MenuItem } from './SubItem';

type SubItemsProps = {
  indentLevel?: number;
  item?: { children?: MenuItem[] } | null;
  withinNestedModGroup?: boolean;
};

const renderSubItems = ({ indentLevel = 0, item, withinNestedModGroup = false }: SubItemsProps) => {
  if (!item || isEmpty(item)) return null;

  const children = item.children ?? [];

  return (
    <>
      {children.map((child, index) => (
        <div key={child.uuid}>
          <SubItem
            item={child}
            order={index + 1}
            indentLevel={indentLevel}
            withinNestedModGroup={withinNestedModGroup}
          />
        </div>
      ))}
    </>
  );
};

export default renderSubItems;
